module.exports = __webpack_public_path__ + "DINNextLTPro-Light.eot?782475d3a7f5233ca247c0ca86c40e34";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Light.eot
// module id = 317
// module chunks = 0